/* ==================================================
 *  Is Touch Device?
 * ==================================================*/

function isTouchDevice() {
  'use strict';
  return (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}
